import { Component } from '@angular/core';
import {BackButtonComponent} from "../../components/ui/back-button/back-button.component";
import {ButtonComponent} from "../../components/ui/button/button.component";
import {ActivatedRoute, Router, RouterOutlet} from "@angular/router";
import {TabComponent} from "../../components/ui/tab/tab.component";
import {TabsComponent} from "../../components/ui/tabs/tabs.component";
import {TitleComponent} from "../../components/ui/title/title.component";
import {TranslateModule} from "@ngx-translate/core";
import {ModalService} from "../../services/modal.service";
import {DeleteConfirmModalComponent} from "../../components/modals/delete-confirm-modal/delete-confirm-modal.component";
import {firstValueFrom, map} from "rxjs";
import {AsyncPipe, NgIf, NgOptimizedImage} from "@angular/common";
import {PointCloudService} from "../../services/point-cloud.service";
import {ProjectAdminAccessDirective} from "../../directives/project-admin-access.directive";

@Component({
  selector: 'app-point-cloud-detail',
  standalone: true,
  imports: [
    BackButtonComponent,
    ButtonComponent,
    RouterOutlet,
    TabComponent,
    TabsComponent,
    TitleComponent,
    TranslateModule,
    AsyncPipe,
    ProjectAdminAccessDirective,
    NgIf,
    NgOptimizedImage
  ],
  templateUrl: './point-cloud-detail.component.html',
  styleUrl: './point-cloud-detail.component.scss'
})
export class PointCloudDetailComponent {
  project$ = this.route.data.pipe(map(data => data['project']));
  pointCloud$ = this.route.data.pipe(map(data => data['pointCloud']));
  standalone$ = this.route.data.pipe(map(data => data['standalone'] ?? false));

  constructor(private route: ActivatedRoute, private router: Router, private modalService: ModalService, private pointCloudService: PointCloudService) {
  }

  async deletePointCloud() {
    const project = await firstValueFrom(this.project$);
    const pointCloud = await firstValueFrom(this.pointCloud$);

    this.modalService.open(DeleteConfirmModalComponent, {
      data: {
        type: 'page.project-point-cloud.delete-point-cloud.entity',
        name: pointCloud.id,
        confirm: async () => {
          await firstValueFrom(this.pointCloudService.delete(pointCloud));
          this.router.navigate(['panel', 'projects', 'detail', project.id, 'point-clouds']);
        },
      }
    });
  }
}
